import { render, staticRenderFns } from "./add-mtc-event.vue?vue&type=template&id=70fcaa0c"
import script from "./add-mtc-event.vue?vue&type=script&lang=js"
export * from "./add-mtc-event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports